import { Status } from "@jti/store";
export const USER_POINTS_PLACEHOLDER = "{#userPoints#}";
export const processLoggedTitle = (status, replaceStringPlaceholder, title = "") => {
    if (typeof title !== "string") {
        return { processedTitle: "", isLoading: false };
    }
    if (title.includes(USER_POINTS_PLACEHOLDER) && status !== Status.COMPLETED && status !== Status.FAILED) {
        return { processedTitle: "", isLoading: true };
    }
    const processedTitle = replaceStringPlaceholder(title, false);
    return { processedTitle, isLoading: false };
};
